import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito saber de cocina o de nutrición?',
    a: 'Para nada. Cada receta te dice exactamente qué poner, cuánto y a qué temperatura. Si sabés apretar un botón en tu Air Fryer, ya sabés todo lo que necesitás.'
  }, {
    q: '¿Sirve si ya sé lo básico de keto?',
    a: 'Justamente para vos es. Sabés lo que es keto, el problema es el día a día, qué cocinás hoy, qué mañana, cómo no caer siempre en lo mismo, ni pedir delivery. El recetario te da 40 opciones listas para usar con tu Air Fryer para que nunca más te quedes sin ideas.'
  }, {
    q: '¿Vale la pena si ya tengo recetas guardadas en Instagram?',
    a: 'Tener recetas guardadas no es lo mismo que tener un plan. Las recetas de Instagram están en inglés, usan ingredientes que no conseguís, o te piden una hora de cocina. Acá tenés 40 recetas probadas, con ingredientes del súper, listas en 20 minutos y todas para tu Air Fryer. Sin buscar, sin filtrar, sin improvisar.'
  }, {
    q: '¿Cuánto tiempo lleva preparar cada receta?',
    a: 'Menos de 20 minutos. La mayoría requiere 5 minutos de preparación y 10-15 minutos en el Air Fryer. Mientras cocina, vos hacés lo tuyo.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Apenas pagás, recibís el link de descarga en tu email. Son archivos PDF que podés ver desde el celular, la tablet o la compu. También incluye versión para imprimir.'
  }];
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-24" data-id="element-64">
      <div className="max-w-[800px] mx-auto" data-id="element-65">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-heading font-bold text-2xl md:text-3xl text-gray-900 text-center mb-10" data-id="element-66">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-67">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-68">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-69">
                <span className="font-bold text-gray-900 pr-4" data-id="element-70">{faq.q}</span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 border-[#00A86B] flex items-center justify-center transition-transform duration-300 ${openIndex === idx ? 'rotate-180 bg-[#00A86B]' : 'bg-transparent'}`} data-id="element-71">
                  <ChevronDownIcon className={`w-5 h-5 ${openIndex === idx ? 'text-white' : 'text-[#00A86B]'}`} data-id="element-72" />
                </div>
              </button>

              <AnimatePresence data-id="element-73">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-74">
                    <div className="p-5 pt-0 text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-50" data-id="element-75">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}